import { useNavigate } from 'react-router-dom'
import { classNames } from 'shared/lib/classNames/classNames'
import { Button } from 'shared/ui/Button'
import cls from './EmptyMomentPage.module.scss'
import whale from 'shared/assets/images/whaleF.png'
import { Text, TextSize, TextWeight } from 'shared/ui/Text/Text'
import React from 'react'

export const EmptyMomentPage = () => {
    const navigate = useNavigate()

    const onRedirectSuggestion = () => {
        navigate('/suggest')
    }

    return (
        <div className={classNames(cls.EmptyMomentPage, {}, [])}>
            <img className={cls.Image} src={whale} alt="whale" />
            <Text size={TextSize.XL} weight={TextWeight.BOLD}>
                Лента кончилась
            </Text>
            <Text className={cls.SecondText}>
                Но новые мечты уже готовятся! Создай свою и она появится здесь
            </Text>
            <Button
                className={cls.Button}
                onClick={onRedirectSuggestion}
                text={'Создать свою мечту'}
            />
        </div>
    )
}
